module.exports = __webpack_public_path__ + "media/icons/message-2ddfb83a.png";